export const RESUME_OPTIONS_EDIT_MODAL_NAME = 'resumeOptionsEdit';
